import { apiClient } from './client';

export type OnboardingStepKey =
  | 'connect_store'
  | 'sync_data'
  | 'run_first_audit'
  | 'view_recommendations'
  | 'configure_schedule'
  | 'review_dashboard';

export interface OnboardingStepStatus {
  key: OnboardingStepKey;
  label: string;
  description: string;
  order: number;
  is_complete: boolean;
  is_auto_complete: boolean;
}

export interface OnboardingProgress {
  completed_count: number;
  total_steps: number;
  progress_percent: number;
  is_complete: boolean;
  is_dismissed: boolean;
  completed_at: string | null;
  steps: OnboardingStepStatus[];
}

export async function getOnboardingProgress(): Promise<OnboardingProgress> {
  const res = await apiClient.get<{ data: OnboardingProgress }>('/onboarding');
  return res.data.data;
}

export async function completeOnboardingStep(step: OnboardingStepKey): Promise<OnboardingProgress> {
  const res = await apiClient.patch<{ data: OnboardingProgress }>(`/onboarding/steps/${step}`);
  return res.data.data;
}

export async function dismissOnboarding(): Promise<OnboardingProgress> {
  const res = await apiClient.delete<{ data: OnboardingProgress }>('/onboarding');
  return res.data.data;
}
